module.exports = __webpack_public_path__ + "static/img/img2.d678c4c7.png";